import React, { Component } from 'react';
import { setValue, getValue } from '../globals/utils';

class ChooseRole extends Component {
     state = { roleListDetails: null };
     componentDidMount() {
          this.checkIfLoggedIn().then(() => {
               this.generateRoles();
          })
     }

     generateRoles = () => {
          const pathMap = {
               'admin': 'adminDashboard',
               'operationshead': 'adminDashboard',
               'chp': 'adminDashboard',
               'operations': 'operations',
               'de': 'dataEntry',
               'ca': 'dashboard',
               'hr': 'dashboard',
               'reportviewer': 'reportViewerDashboard',
               'documentviewer': 'documentViewerDashboard',
               'qc': 'qcDashboard'
          }

          let roleListDetails = null;
          let roleCodeList = null;
          let roleList = null;
          getValue().then((payloadData) => {
               if (payloadData) {
                    // Normalize stored role codes (some environments may store mixed case)
                    roleCodeList = (payloadData['roleCodeList'] || []).map(c => String(c || '').toLowerCase());
                    roleList = payloadData['roleList'];
                    roleListDetails = roleList.map(data => {
                         const codeNorm = String((data && data.code) || '').toLowerCase();
                         const nameNorm = String((data && data.name) || '').toLowerCase();
                         if (roleCodeList.includes(codeNorm)) {
                              // Resolve route path robustly: prefer code map, fallback by name
                              let resolvedPath = pathMap[codeNorm];
                              if (!resolvedPath) {
                                   if (nameNorm.includes('client') && nameNorm.includes('admin')) {
                                        resolvedPath = 'dashboard';
                                   } else if (nameNorm === 'qc' || nameNorm.includes('quality')) {
                                        resolvedPath = 'qcDashboard';
                                   } else if (nameNorm.includes('report')) {
                                        resolvedPath = 'reportViewerDashboard';
                                   } else if (nameNorm.includes('document')) {
                                        resolvedPath = 'documentViewerDashboard';
                                   }
                              }
                              return (
                                   <div
                                        className='user-card card-border'
                                        onClick={() => this.reDirect(resolvedPath, codeNorm, data.priority, data.id)}
                                        key={codeNorm || data.code}
                                   >
                                        {data.code === 'Operations' ? <img src="/images/icons/icon-user-management.svg" alt="Operations" /> :
                                             <img src="/images/icons/icon-user-dark.svg" alt="user" />}
                                        <div className='clr20' />
                                        <h6>{data.name}</h6>
                                        <div className='sub-heading2'>Choose</div>
                                   </div>
                              )
                         }
                         else {
                              return null
                         }
                    })
                    this.setState({ roleListDetails: roleListDetails })
               }
          })
     }

     reDirect = async (path, code, rolePriority, roleId) => {
          // If backend sent unknown mapping, don't navigate to a broken path
          if (!path) {
               console.warn('ChooseRole: Unknown role mapping', { code, rolePriority, roleId });
               return;
          }
          const roleCodeNorm = String(code || '').toLowerCase();
          // Derived flags must be updated on role switch, otherwise UI/guards behave like old role
          const isAdminOrChp = ['admin', 'operationshead', 'chp'].includes(roleCodeNorm);
          const isLoggedByOperations = roleCodeNorm === 'operations';
          await setValue('rolePath', path);
          await setValue('roleCode', roleCodeNorm); // Backend RBAC: axiosConfig sends this as X-Acting-Role on every request
          // Ensure numeric priority for comparisons in PrivateRoute
          const priorityNum = rolePriority !== undefined && rolePriority !== null && rolePriority !== '' ? Number(rolePriority) : '';
          await setValue('rolePriority', Number.isNaN(priorityNum) ? rolePriority : priorityNum)
          await setValue('roleId', roleId)
          await setValue('isAdminOrChp', isAdminOrChp);
          await setValue('isLoggedByOperations', isLoggedByOperations);
          document.location.href = `/${path}`;
     }

     checkIfLoggedIn = () => {
          return new Promise((resolve) => {
               getValue('isloggedin').then(async (lLoggedIn) => {
                    if (!lLoggedIn) {
                         window.location.href = '/home';
                    } else {
                         await setValue('rolePath', '')
                         await setValue('rolePriority', '')
                         // await setValue('clientId', null)
                         await setValue('roleId', '');
                    }
                    resolve();
               });
          })
     }



     render = () => {


          // if (getValue('rolePriority') === getValue('roleMap')['admin']) {
          //      roleName = 'Admin'
          // } else if (getValue('rolePriority') === getValue('roleMap')['chp']) {
          //      roleName = 'CHP'
          // } else if (getValue('rolePriority') === getValue('roleMap')['operationshead']) {
          //      roleName = 'Operations Head'
          // }  else if (getValue('rolePriority') === getValue('roleMap')['de']) {
          //      roleName = 'Data Entry'
          // }


          return (
               <>
                    {this.state.roleListDetails && <div className='choose_role_wrap'>
                         <div className='choose_role_container'>
                              <div className='companylogoclass'>
                                   <img src="/images/logo.svg" alt="glasscase" width='200px' />
                              </div>
                              <h6 className='text-center choose_role_sub'>
                                   Choose a Role
                              </h6>
                              <div className='choose_role_wrapper'>
                                   {this.state.roleListDetails}
                              </div>
                              {/* <div className='user-card card-border' onClick={() => this.reDirect('adminDashboard')}>
                                   <img src="/images/icons/icon-user-dark.svg" alt="user" />
                                   <div className='clr20' />
                                   <h6>{roleName}</h6>
                                   <div className='sub-heading2'>Choose</div>
                              </div>
                              <div className='user-card card-border' onClick={() => this.reDirect('operations')}>
                                   <img src="/images/icons/icon-user-management.svg" alt="Operations" />
                                   <div className='clr20' />
                                   <h6>Operations</h6>
                                   <div className='sub-heading2'>Choose</div>
                              </div> */}
                         </div>
                    </div>}
               </>
          );
     }
}

export default ChooseRole;